export class PreloginRequest {
    email: string;

    constructor(email: string) {
        this.email = email;
    }
}
